module.exports = __webpack_public_path__ + "static/img/code-alipay.fe633d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/code-alipay.png
// module id = 6uTR
// module chunks = 1